import { render, staticRenderFns } from "./TaskDetailsBottom.vue?vue&type=template&id=7091205d&"
import script from "./TaskDetailsBottom.vue?vue&type=script&lang=js&"
export * from "./TaskDetailsBottom.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailsBottom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports